import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
/* eslint-disable no-console */
import { useEffect, useContext } from 'react';
import _isEmpty from 'lodash/isEmpty';
import { GoogleReCaptchaContext } from 'react-google-recaptcha-v3';
import { DEFAULT_RETRIES } from './RecaptchaProvider.constants';
import { RecaptchaContext } from './RecaptchaProvider.context';
import { getSiteKey, isRecaptchaProviderLoaded } from './RecaptchaProvider.utils';
import retry from '../../modules/foundation/services/retry';
export function useRecaptcha() {
  var _useContext = useContext(RecaptchaContext),
    loaded = _useContext.loaded,
    setLoaded = _useContext.setLoaded;
  var context = useContext(GoogleReCaptchaContext);
  var siteKey = getSiteKey();
  var siteKeyAvailable = !!siteKey;
  var getToken = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(action) {
      var _ref2, executeRecaptcha, token;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _ref2 = context || {}, executeRecaptcha = _ref2.executeRecaptcha;
            if (siteKeyAvailable) {
              _context3.next = 3;
              break;
            }
            return _context3.abrupt("return", null);
          case 3:
            if (loaded) {
              _context3.next = 5;
              break;
            }
            return _context3.abrupt("return", null);
          case 5:
            if (executeRecaptcha) {
              _context3.next = 8;
              break;
            }
            console.error('executeRecaptcha is not defined and should be');
            return _context3.abrupt("return", null);
          case 8:
            _context3.prev = 8;
            _context3.next = 11;
            return retry( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
              return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) switch (_context.prev = _context.next) {
                  case 0:
                    return _context.abrupt("return", executeRecaptcha(action));
                  case 1:
                  case "end":
                    return _context.stop();
                }
              }, _callee);
            })), DEFAULT_RETRIES);
          case 11:
            token = _context3.sent;
            if (_isEmpty(token)) {
              // retry if google returned an empty token
              token = retry( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
                return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                  while (1) switch (_context2.prev = _context2.next) {
                    case 0:
                      return _context2.abrupt("return", executeRecaptcha(action));
                    case 1:
                    case "end":
                      return _context2.stop();
                  }
                }, _callee2);
              })), DEFAULT_RETRIES);
            }
            return _context3.abrupt("return", token);
          case 16:
            _context3.prev = 16;
            _context3.t0 = _context3["catch"](8);
            // eslint-disable-next-line no-console
            console.error(_context3.t0);
            return _context3.abrupt("return", null);
          case 20:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[8, 16]]);
    }));
    return function getToken(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  useEffect(function () {
    if (!setLoaded) {
      return;
    }
    if (!siteKeyAvailable) {
      setLoaded(true);
    } else {
      setLoaded(isRecaptchaProviderLoaded(context));
    }
  }, [context]);
  var finalLoaded = !siteKeyAvailable ? true : loaded;
  return [getToken, finalLoaded];
}